export const convertPostActiveLimitsPayload = (data) => ({
  slots: Number(data.slots) || null,
  liveCasino: Number(data.liveCasino) || null,
  digsport: Number(data.digsport) || null,
})